import logoBlack from "@/assets/afm-logo-black.png";
import logoWhite from "@/assets/afm-logo-white.png";

export const Logo = ({ variant = "black", className = "", imgClassName = "" }) => {
  const src = variant === "white" ? logoWhite : logoBlack;
  return (
    <div className={`flex items-center ${className}`} data-testid="afm-logo">
      <img
        src={src}
        alt="Always Fre$h Music"
        className={imgClassName || "h-11 w-auto object-contain"}
        draggable={false}
      />
    </div>
  );
};

// Clean "AF" monogram isotype (no outer circle/text) — transparent, inherits currentColor.
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 60 48" className={className} fill="none" data-testid="afm-logomark" role="img" aria-label="Always Fresh Music">
    <text x="30" y="37" textAnchor="middle" fontFamily="Georgia, 'Times New Roman', serif" fontWeight="700" fontSize="40" letterSpacing="-3" fill="currentColor">AF</text>
  </svg>
);
